import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ViewFieldSupport } from "@air/api/types";
import React, { forwardRef, memo } from "react";
import { useSelector } from "react-redux";
import { NameHeader } from "~/components/TableView/NameHeader";
import { SortableHeader } from "~/components/TableView/SortableHeader";
import TableHeader from "~/components/TableView/TableHeader";
import { getVisibilityToggleTypeFromString } from "~/constants/configViews";
import { DATE_CREATED_HEADER, DATE_MODIFIED_HEADER, FILE_HEADER, RESOLUTION_HEADER, SIZE_HEADER, TYPE_HEADER } from "~/constants/testIDs";
import { visibleConfigViewOptionsSelector } from "~/store/configViews/selectors";
import { StaticHeader } from "./StaticHeader";
import { makeActiveTableColumnFromOption } from "./tableColumnWidthsUtils";
import { useTableView } from "./TableViewContext";
export const dataTestIdMap = {
    boardCount: "",
    openCommentCount: "",
    tagCount: "",
    dateCreated: DATE_CREATED_HEADER,
    dateModified: DATE_MODIFIED_HEADER,
    ext: FILE_HEADER,
    size: SIZE_HEADER,
    type: TYPE_HEADER,
    resolution: RESOLUTION_HEADER,
    titleAndMetadata: "",
    dateTaken: "dateTaken",
    dateUploaded: "dateUploaded",
    uploadedBy: "uploadedBy"
};
const _TableHeaders = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { CustomFieldTableHeaderComponent, horizontalPadding, topPos } = param;
    const visibleConfigViewOptions = useSelector(visibleConfigViewOptionsSelector);
    const { getHeaderResizeHandle, getColumnWidthStyle, getTableWidthStyle } = useTableView();
    return /*#__PURE__*/ _jsxs(TableHeader, {
        ref: ref,
        style: {
            top: topPos
        },
        innerStyle: {
            paddingLeft: horizontalPadding,
            paddingRight: horizontalPadding,
            ...getTableWidthStyle()
        },
        children: [
            /*#__PURE__*/ _jsx(NameHeader, {}),
            visibleConfigViewOptions.map((option)=>{
                const optionColumn = makeActiveTableColumnFromOption(option.fieldName, option.isCustomField, option.customFieldId);
                if (option.isCustomField && option.customFieldId && option.label !== undefined) {
                    return /*#__PURE__*/ _jsx(CustomFieldTableHeaderComponent, {
                        customFieldName: option.label,
                        style: getColumnWidthStyle(optionColumn),
                        resizeHandle: getHeaderResizeHandle(optionColumn)
                    }, option.customFieldId);
                }
                const toggleType = getVisibilityToggleTypeFromString(option.fieldName);
                if (toggleType) {
                    const toggleSortBy = option.fieldName;
                    if (toggleSortBy && option.supports.includes(ViewFieldSupport.sort)) {
                        return /*#__PURE__*/ _jsx(SortableHeader, {
                            title: option.label,
                            sortingType: option.fieldName,
                            "data-testid": dataTestIdMap[toggleType],
                            style: getColumnWidthStyle(optionColumn),
                            resizeHandle: getHeaderResizeHandle(optionColumn)
                        }, option.fieldName);
                    } else {
                        return /*#__PURE__*/ _jsx(StaticHeader, {
                            title: option.label,
                            "data-testid": dataTestIdMap[toggleType],
                            style: getColumnWidthStyle(optionColumn),
                            resizeHandle: getHeaderResizeHandle(optionColumn)
                        }, option.fieldName);
                    }
                }
                return null;
            })
        ]
    });
});
_TableHeaders.displayName = "_TableHeaders";
export const TableHeaders = /*#__PURE__*/ memo(_TableHeaders);
TableHeaders.displayName = "PrivateTableHeaders";
